import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { catchError, map, merge, of, startWith, switchMap } from 'rxjs';
import { UsersService } from 'src/app/private/services/users.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { AddUserComponent } from "../../components/add-user/add-user.component";
import { Menu } from 'primeng/menu';
import { ResetPasswordComponent } from 'src/app/private/components/user/reset-password/reset-password.component';
import { DeleteUserComponent } from 'src/app/private/components/user/delete-user/delete-user.component';

@Component({
  selector: 'app-configure-users',
  imports: [SharedModule, ToolBarComponent, AddUserComponent, ResetPasswordComponent, DeleteUserComponent],
  templateUrl: './configure-users.component.html',
  styleUrl: './configure-users.component.scss'
})
export class ConfigureUsersComponent {

  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  searchQuery = new FormControl();
  isAddUser: boolean = false;
  isEditUser: boolean = false;
  userDataToEdit: any = {};
  isResetPassword: boolean = false;
  isDeleteUser: boolean = false;


  items: any[] = [];
  // displayedColumns: string[] = ["username", "fname", 'lname', "email", "role", "date", "status", "action"];


  columns: any[] = [
    // { field: 'user', header: 'Lead Owner', type: 'nested' },
    // { field: 'contact_name', header: 'Contact Name', sortable: true },
    // { field: 'contact_email', header: 'Contact Email' },
    // { field: 'lead_source', header: 'Lead Source' },
    // { field: 'lead_status', header: 'Lead Status' },
    // { field: 'contact_phone', header: 'Contact Phone' },
    // { field: 'is_active', header: 'Active', type: 'boolean' }, // Boolean filter example
    { field: 'username', header: 'Username' },
    { field: 'fname', header: 'First Name' },
    { field: 'lname', header: 'Last Name' },
    { field: 'email', header: 'Email' },
    { field: 'role', header: 'Role' , type:'role'},
    { field: 'createdAt', header: 'Date', type:'date' },
    { field: 'status', header: 'Status' },
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];


  constructor(
    private api: UsersService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    
  }


  getMenuItems(menu: Menu, rowData: any) {
    return [
      {
        label: 'Options',
        items: [
          {
            label: 'Edit',
            icon: 'pi pi-fw pi-pencil',
            command: () => {
              menu.hide();
              console.log('Edit', rowData);
              this.isEditUser = true;
              this.userDataToEdit = rowData;
            }
          },
          {
            label: 'Reset Password',
            icon: 'pi pi-fw pi-refresh',
            command: () => {
              this.isResetPassword = true;
              this.userDataToEdit = rowData;
            }
          },
          {
            label: 'Delete Account',
            icon: 'pi pi-fw pi-trash',
            styleClass: 'delete-menu-item',
            command: () => {
              this.isDeleteUser = true;
              this.userDataToEdit = rowData;
            }
          }
        ]
      }
    ];
  }
  

  
  loadData(event: any) {
    const page = event.first / event.rows;
    const size = event.rows;
    let param = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
      },
      page: page,
      limit: size,
      filter: this.searchQuery?.value,
    };
    this.loading = true;
    return this.api.getAllUsers(param).subscribe(
      {
        next: (data: any) => {
          this.initialLoad = false;
          this.loading = false;
          this.dataSource = data?.rows || [];
          this.totalRecords = data?.count || 0;
        },
        error: (e) => {
          this.initialLoad = false;
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error in fetching data' });
        },
      }
    );
  }
  


}
